import React, { useContext, useState, useEffect } from "react";
import { FormBuilderContext } from "../context/context";
import "./staticStyles.css";
import "./styles.scss";

import StyledInput from "../components/StyledInput";
import StyledCheckbox from "../components/StyledCheckbox";
import StyledRadioButton from "../components/StyledRadioButton";
import StyledSubmitButton from "../components/StyledSubmitButton";
import StyledSelect from "../components/StyledSelect";
import StyledTextarea from "../components/StyledTextarea";
import SubmitButtonWrapper from "../components/StyledSubmitButtonWrapper";
import StyledFieldLabel from "../components/StyledLabel";
import StyledDescription from "../components/StyledDescription";
import StyledCheckboxLabel from "../components/StyledCheckboxLabel";
import StyledRadioLabel from "../components/StyledRadioLabel";
import StyledErrorText from "../components/StyledErrorText";
import StyledErrorHead from "../components/StyledErrorHead";
import StyledToggleButton from '../components/StyledToggleButton';
import StyledToggleButtonLabel from "../components/StyledToggleButtonLabel";

const FormPreview = () => {
  const { state } = useContext(FormBuilderContext);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState("option1");
  const buttonText = state.submitButtonText || "Submit";

  // Declare state variables for label and input flex basis
  const [labelFlexBasis, setLabelFlexBasis] = useState('auto');
  const [inputFlexBasis, setInputFlexBasis] = useState('auto');
  const [labelMargin, setLabelMargin] = useState('0');

  // UseEffect to adjust flex basis based on alignment selection
  useEffect(() => {
    if (state.fieldLabelAlignment === 'row') {
      setLabelFlexBasis('25%');
      setInputFlexBasis('75%');
      setLabelMargin('auto 0');
    } else {
      setLabelFlexBasis('auto');
      setInputFlexBasis('auto');
      setLabelMargin(null);
    }
  }, [state.fieldLabelAlignment]);

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle the submit action here
  };
  return (
    <div className="form-preview">
      <form className="form" id="pardot-form" onSubmit={handleSubmit}>
        {state.addErrors &&
          <StyledErrorHead
            type="text"
            styling={state}>
            Please correct the errors below:
          </StyledErrorHead>
        }
        <div
          className="form-field"
          style={{ paddingTop: `${state.fieldTopSpacing}px` }}
        >
          <div
            className="field-wrapper"
            style={{ display: 'flex', flexDirection: `${state.fieldLabelAlignment}` }}
          >
            {!state.removeFieldLabels &&
              <StyledFieldLabel
                type="text"
                style={{ margin: labelMargin, flexShrink: 0, flexBasis: labelFlexBasis }}
                styling={state}>
                Input Label
              </StyledFieldLabel>
            }
            <StyledInput
              type="text"
              style={{ flexGrow: 1, flexBasis: inputFlexBasis }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              styling={state} // pass the state object as a single prop
              $isHovered={isHovered} // pass the isHovered state
            />
          </div>
          {state.addDescription &&
            <StyledDescription
              type="text"
              styling={state}>
              Description
            </StyledDescription>
          }
          {state.addErrors &&
            <StyledErrorText
              type="text"
              styling={state}>
              This field is required.
            </StyledErrorText>
          }
        </div>
        <div
          className="form-field"
          style={{ paddingTop: `${state.selectTopSpacing}px` }}
        >
          <div
            className="field-wrapper"
            style={{ display: 'flex', flexDirection: `${state.fieldLabelAlignment}` }}
          >
            {!state.removeFieldLabels &&
              <StyledFieldLabel
                type="text"
                style={{ margin: labelMargin, flexShrink: 0, flexBasis: labelFlexBasis }}
                styling={state}>
                Select Label
              </StyledFieldLabel>
            }
            <StyledSelect
              type="select"
              style={{ flexGrow: 1, flexBasis: inputFlexBasis }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              styling={state} // pass the state object as a single prop
              $isHovered={isHovered} // pass the isHovered state
            />
          </div>
          {state.addDescription &&
            <StyledDescription
              type="text"
              styling={state}>
              Description
            </StyledDescription>
          }
          {state.addErrors &&
            <StyledErrorText
              type="text"
              styling={state}>
              This field is required.
            </StyledErrorText>
          }
        </div>
        <div
          className="form-field"
          style={{ paddingTop: `${state.textAreaTopSpacing}px` }}
        >
          <div
            className="field-wrapper"
            style={{ display: 'flex', flexDirection: `${state.fieldLabelAlignment}` }}
          >
            {!state.removeFieldLabels &&
              <StyledFieldLabel
                type="text"
                style={{ margin: labelMargin, flexShrink: 0, flexBasis: labelFlexBasis }}
                styling={state}>
                Textarea Label
              </StyledFieldLabel>
            }
            <StyledTextarea
              type="textarea"
              style={{ flexGrow: 1, flexBasis: inputFlexBasis }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              styling={state} // pass the state object as a single prop
              $isHovered={isHovered} // pass the isHovered state
            />
          </div>
          {state.addDescription &&
            <StyledDescription
              type="text"
              styling={state}>
              Description
            </StyledDescription>
          }
          {state.addErrors &&
            <StyledErrorText
              type="text"
              styling={state}>
              This field is required.
            </StyledErrorText>
          }
        </div>
        {state.addCheckbox && (
          <div className="form-field">
            <div
              className="field-wrapper"
              style={{ display: 'flex', flexDirection: `${state.fieldLabelAlignment}` }}
            >
              <StyledFieldLabel
                type="text"
                style={{ flexShrink: 0, flexBasis: labelFlexBasis }}
                styling={state}>
                Checkbox Label
              </StyledFieldLabel>
              <div>
                <span
                  style={{ float: `${state.checkboxAlignment}` }}
                >
                  <StyledCheckbox
                    id="exampleCheckbox"
                    styling={state} />
                  <StyledCheckboxLabel
                    htmlFor="exampleCheckbox"
                    styling={state}>
                    Check value label
                  </StyledCheckboxLabel>
                </span>
                <span
                  style={{ float: `${state.checkboxAlignment}` }}
                >
                  <StyledCheckbox
                    id="exampleCheckbox2"
                    styling={state} />
                  <StyledCheckboxLabel
                    htmlFor="exampleCheckbox2"
                    styling={state}>
                    Check value label
                  </StyledCheckboxLabel>
                </span>
              </div>
            </div>
            {/* <label htmlFor="exampleCheckbox">Checkbox inline label</label> */}
            {state.addDescription &&
              <StyledDescription
                type="text"
                styling={state}>
                Description
              </StyledDescription>
            }
            {state.addErrors &&
              <StyledErrorText
                type="text"
                styling={state}>
                This field is required.
              </StyledErrorText>
            }
          </div>
        )}
        {state.addRadioButton && (
          <div className="form-field">
            <div
              className="field-wrapper"
              style={{ display: 'flex', flexDirection: `${state.fieldLabelAlignment}` }}
            >
              <StyledFieldLabel
                type="text"
                style={{ flexShrink: 0, flexBasis: labelFlexBasis }}
                styling={state}>
                Radio Label
              </StyledFieldLabel>
              <div>
                {/* Group of radio buttons */}
                <span
                  style={{ float: `${state.radioAlignment}` }}
                >
                  <StyledRadioButton
                    id="option1"
                    name="exampleRadioGroup"
                    checked={selectedRadio === "option1"}
                    onChange={() => setSelectedRadio("option1")}
                    styling={state}
                  />
                  <StyledRadioLabel
                    htmlFor="option1"
                    styling={state}>
                    Radio value label
                  </StyledRadioLabel>
                </span>
                {/* <label htmlFor="option1">Example Radio Button 1</label> */}
                <span
                  style={{ float: `${state.radioAlignment}` }}
                >
                  <StyledRadioButton
                    id="option2"
                    name="exampleRadioGroup"
                    checked={selectedRadio === "option2"}
                    onChange={() => setSelectedRadio("option2")}
                    styling={state}
                  />
                  <StyledRadioLabel
                    htmlFor="option2"
                    styling={state}>
                    Radio value label
                  </StyledRadioLabel>
                </span>
                {/* <label htmlFor="option2">Example Radio Button 2</label> */}
              </div>
            </div>
            {state.addDescription &&
              <StyledDescription
                type="text"
                styling={state}>
                Description
              </StyledDescription>
            }
            {state.addErrors &&
              <StyledErrorText
                type="text"
                styling={state}>
                This field is required.
              </StyledErrorText>
            }
          </div>
        )}

        {state.addToggle && (
          <div className="form-field">
            <div className="field-wrapper" style={{ display: 'flex', flexDirection: `${state.fieldLabelAlignment}` }}>
              <StyledFieldLabel
                type="text"
                style={{ flexShrink: 0, flexBasis: labelFlexBasis }}
                styling={state}>
                Toggle Label
              </StyledFieldLabel>
              <div style={{ display: 'flex', marginBottom: `${state.toggleMarginBottom}px` }}>
                <StyledToggleButton id="exampleToggle1" styling={state} />
                <label htmlFor="exampleToggle1">
                </label>
                <StyledToggleButtonLabel
                  htmlFor="exampleToggle2"
                  styling={state}>
                  Toggle Label 1
                </StyledToggleButtonLabel>
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                <StyledToggleButton id="exampleToggle2" styling={state} />
                <label htmlFor="exampleToggle2">
                </label>
                <StyledToggleButtonLabel
                  htmlFor="exampleToggle2"
                  styling={state}>
                  Toggle Label 2
                </StyledToggleButtonLabel>
              </div>
            </div>
            {state.addDescription && (
              <StyledDescription type="text" styling={state}>
                Description
              </StyledDescription>
            )}
            {state.addErrors && (
              <StyledErrorText type="text" styling={state}>
                This field is required.
              </StyledErrorText>
            )}
          </div>
        )}

        <SubmitButtonWrapper theme={state}>
          <StyledSubmitButton theme={state}>{buttonText}</StyledSubmitButton>
        </SubmitButtonWrapper>
      </form>
    </div>
  );
};

export default FormPreview;
